const defaultState = {
  ga: undefined,
  localytics: undefined,
  criteo: undefined,
};

export default function analyticsReducer(state = defaultState) {
  return state;
}
